var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillGapsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_10",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 17.5C3.40278 17.4444 3.15625 17.3021 2.92708 17.0729C2.69792 16.8438 2.55556 16.5972 2.5 16.3333L16.3333 2.5C16.625 2.56944 16.875 2.71181 17.0833 2.92708C17.2917 3.14236 17.4375 3.38889 17.5208 3.66667L3.66667 17.5ZM2.5 12.25V9.91667L9.91667 2.5H12.25L2.5 12.25ZM2.5 5.83333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H5.83333L2.5 5.83333ZM14.1667 17.5L17.5 14.1667V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H14.1667ZM7.75 17.5L17.5 7.75V10.0833L10.0833 17.5H7.75Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillGapsIcon);
export default __webpack_public_path__ + "static/media/fillGapsIcon.f0bfa4dcf52148ddb969d087f6e035ed.svg";
export { ForwardRef as ReactComponent };